"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECKS_CHANGED = exports.ROUTE_ABANDONED = exports.ROUTE_TIMEOUT_EXPIRED = exports.ROUTE_FAILED = exports.ROUTE_SUCCEEDED = exports.ROUTE_UNEXPECTED = exports.ROUTE_STARTED = void 0;
var ROUTE_STARTED = 'ROUTE_STARTED';
exports.ROUTE_STARTED = ROUTE_STARTED;
var ROUTE_UNEXPECTED = 'ROUTE_UNEXPECTED';
exports.ROUTE_UNEXPECTED = ROUTE_UNEXPECTED;
var ROUTE_SUCCEEDED = 'ROUTE_SUCCEEDED';
exports.ROUTE_SUCCEEDED = ROUTE_SUCCEEDED;
var ROUTE_FAILED = 'ROUTE_FAILED';
exports.ROUTE_FAILED = ROUTE_FAILED;
var ROUTE_TIMEOUT_EXPIRED = 'ROUTE_TIMEOUT_EXPIRED';
exports.ROUTE_TIMEOUT_EXPIRED = ROUTE_TIMEOUT_EXPIRED;
var ROUTE_ABANDONED = 'ROUTE_ABANDONED';
exports.ROUTE_ABANDONED = ROUTE_ABANDONED;
var CHECKS_CHANGED = 'CHECKS_CHANGED';
exports.CHECKS_CHANGED = CHECKS_CHANGED;